import {Eye} from "react-feather";
import {CreditInfo} from "../../..";
import {useTheme} from "styled-components";
import {useAppSelector, useModal} from "hooks";
import {IconButton, Row, Typography} from "components";
import {TableRow, TableCell, TableBody} from "@mui/material";

interface BodyProps {}

export const Body: React.FC<BodyProps> = () => {
  const {openModal} = useModal();
  const {blackWhite} = useTheme();
  const {client} = useAppSelector("clients");
  const {formularios} = client;

  return (
    <TableBody>
      {formularios.map((credit, key) => {
        const {id, codigo, estatus} = credit;
        return (
          <TableRow hover key={`${id}-${key}`} tabIndex={-1}>
            <TableCell padding="none">
              <Row alignItems="center">
                <Typography className="line-clamp-1">#{codigo}</Typography>
              </Row>
            </TableCell>
            <TableCell>
              <Typography>{estatus}</Typography>
            </TableCell>
            <TableCell>
              {credit.finanzas ? (
                <IconButton
                  icon={<Eye color={blackWhite} />}
                  onClick={() => openModal(<CreditInfo credit={credit} />)}
                />
              ) : (
                <Typography>No disponible</Typography>
              )}
            </TableCell>
          </TableRow>
        );
      })}
    </TableBody>
  );
};
